// UserForm.jsx

import React, { useState, useEffect } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { Button, Typography } from '@mui/material';
import { useSnackbar } from '../../../context/SnackbarContext';
import { useTranslation } from 'react-i18next';
import UserTypeSelect from '../../common/controls/UserTypeSelect';
import { useUpdateUserType } from '../../../hooks/admin/useUpdateUserType';

export default function ChangeUserType({ office = null, user = null, open, onClose, toggleUserListTrigger = null }) {
  const { t } = useTranslation('common'); 
  const { showSnackbar } = useSnackbar();

  const handleCancel = () => {
    onClose();
  };

  const [userType, setUserType] = useState(office?.UserOffice?.type || "");

  const onUpdateSuccess = () => {
    showSnackbar(t('users.messages.update_success'), "success");
    toggleUserListTrigger();
    handleCancel();
  };

  const { update, updating } = useUpdateUserType(onUpdateSuccess);

  const handleChange = (value) => {
    setUserType(value);
  };

  const handleSave = async () => {
    try {
      let data = {
        "user_id": user.id,
        "office_id": office.id,
        "type": userType
      }
      await update(office.UserOffice.id, data);
    } catch (err) {
      console.log("err.response", err.response);
      showSnackbar(t('users.messages.update_fail'), "error");
    }
  };

  return (
    <Dialog onClose={handleCancel} open={open} disableRestoreFocus>
    <DialogTitle>
      <>
        <Typography fontSize={20} fontWeight={700}>{office?.name}</Typography>
        <Typography fontSize={20} fontWeight={700}>{user?.name} </Typography>
      </>
    </DialogTitle>

    <DialogContent dividers>
      <UserTypeSelect 
        label='Account Type'
        value={office?.UserOffice?.type}
        onChange={handleChange}
      />
    </DialogContent>

    <DialogActions>
      <Button 
        onClick={handleSave}
      >
        Save
      </Button>
      <Button onClick={handleCancel}>Cancel</Button>
    </DialogActions>
    </Dialog>
  );
}